module.exports = __webpack_public_path__ + "static/img/6.2d1c2d12.png";